import React, { useState } from 'react'; // Import useState
import { Link } from 'react-router-dom';
import { FaSlidersH } from 'react-icons/fa';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false); // Define state using useState

  const handleToggle = () => {
    setIsOpen(!isOpen); // Toggle the state
  };

  return (
    <div>
      <nav className='Navbar'>
        <div className='Navbar-title'>
          <h1>
            <Link to="/"> Usama Ali</Link>
          </h1>
        </div>
        <div className={`Navbar-list ${isOpen ? 'active' : ''}`}>
          <li>
            <Link to="/skills" onClick={handleToggle}> Skills</Link>
          </li>
          <li>
            <Link to="/projects" onClick={handleToggle}> Projects</Link>
          </li>
          <li>
            <Link to="/contact" onClick={handleToggle}> Contact</Link>
          </li>
          <li>
            <Link to="/Docs/Resume.pdf" target="_blank" onClick={handleToggle}> Resume</Link>
          </li>
        </div>
        <div className='Navbar-toggle-icon' onClick={handleToggle}>
          <FaSlidersH />
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
